export default async (actionName, keyValuePairs) => window?.newrelic?.addPageAction(actionName, keyValuePairs);

const logNewRelicJSError = async (err) => window?.newrelic?.noticeError(err);

export {
  logNewRelicJSError
};
